// Reducers & Effects
import { ApplicationConfig, isDevMode } from '@angular/core';
import { provideEffects } from '@ngrx/effects';
import { provideState, provideStore } from '@ngrx/store';
import { provideStoreDevtools } from '@ngrx/store-devtools';
import { NotificationsEffects } from 'app/modules/notification/store/notification.effects';
import { notificationsReducer } from 'app/modules/notification/store/notification.reducer';
import { PlaceTypesEffects } from 'app/modules/sho_management_pro/booking/modules/place-types/store/place-types.effects';
import { placeTypesReducer } from 'app/modules/sho_management_pro/booking/modules/place-types/store/place-types.reducer';
import { BookingsEffects } from 'app/modules/sho_management_pro/booking/store/booking/bookings.effects';
import { bookingsReducer } from 'app/modules/sho_management_pro/booking/store/booking/bookings.reducer';
import { SearchLocationsEffects } from 'app/modules/sho_management_pro/booking/store/searchLocations.effects';
import {
    coordinatesReducer,
    searchLocationsReducer,
} from 'app/modules/sho_management_pro/booking/store/searchLocations.reducer';
import { CommonEffects } from 'app/modules/sho_management_pro/common/store/common.effects';
import { commonReducer } from 'app/modules/sho_management_pro/common/store/common.reducer';
import { EmployeeRolesEffects } from 'app/modules/sho_management_pro/employee-role/store/employee-roles.effects';
import { employeeRolesReducer } from 'app/modules/sho_management_pro/employee-role/store/employee-roles.reducer';
import { EmployeeEffects } from 'app/modules/sho_management_pro/employee/store/employee.effects';
import { employeesReducer } from 'app/modules/sho_management_pro/employee/store/employee.reducer';
import { ExpenseStatusEffects } from 'app/modules/sho_management_pro/expenses/store/expense-status/expense-status.effects';
import { expenseStatusReducer } from 'app/modules/sho_management_pro/expenses/store/expense-status/expense-status.reducer';
import { ExpenseTypesEffects } from 'app/modules/sho_management_pro/expenses/store/expense-type/expense-type.effects';
import { expenseTypesReducer } from 'app/modules/sho_management_pro/expenses/store/expense-type/expense-type.reducer';
import { ExpensesEffects } from 'app/modules/sho_management_pro/expenses/store/expense/expenses.effects';
import { expensesReducer } from 'app/modules/sho_management_pro/expenses/store/expense/expenses.reducer';
import { CommissionsEffects } from 'app/modules/sho_management_pro/finances/store/commissions/commissions.effects';
import { commissionsReducer } from 'app/modules/sho_management_pro/finances/store/commissions/commissions.reducer';
import { ConcessionSalesEffects } from 'app/modules/sho_management_pro/finances/store/concession-sales/concession-sales.effects';
import { ConcessionSalesReducer } from 'app/modules/sho_management_pro/finances/store/concession-sales/concession-sales.reducer';
import { NoveltiesSalesEffects } from 'app/modules/sho_management_pro/finances/store/novelties-sales/novelties-sales.effects';
import { NoveltiesSalesReducer } from 'app/modules/sho_management_pro/finances/store/novelties-sales/novelties-sales.reducer';
import { OtherSalesEffects } from 'app/modules/sho_management_pro/finances/store/other-sales/other-sales.effects';
import { otherSalesReducer } from 'app/modules/sho_management_pro/finances/store/other-sales/other-sales.reducer';
import { OtherVendorsSalesEffects } from 'app/modules/sho_management_pro/finances/store/other-vendors-sales/other-vendors-sales.effects';
import { otherVendorsSalesReducer } from 'app/modules/sho_management_pro/finances/store/other-vendors-sales/other-vendors-sales.reducer';
import { ParkingSalesEffects } from 'app/modules/sho_management_pro/finances/store/parking-sales/parking-sales.effects';
import { parkingSalesReducer } from 'app/modules/sho_management_pro/finances/store/parking-sales/parking-sales.reducer';
import { RidesSalesEffects } from 'app/modules/sho_management_pro/finances/store/rides-sales/rides-sales.effects';
import { ridesSalesReducer } from 'app/modules/sho_management_pro/finances/store/rides-sales/rides-sales.reducer';
import { TerminalSalesEffects } from 'app/modules/sho_management_pro/finances/store/terminal-sales/terminal-sales.effects';
import { terminalSalesReducer } from 'app/modules/sho_management_pro/finances/store/terminal-sales/terminal-sales.reducer';
import { TotalGrossEffects } from 'app/modules/sho_management_pro/finances/store/total-gross/total-gross.effects';
import { TotalGrossReducer } from 'app/modules/sho_management_pro/finances/store/total-gross/total-gross.reducer';
import { VipUpgradesEffects } from 'app/modules/sho_management_pro/finances/store/vip-upgrades/vip-upgrades.effects';
import { vipUpgradesReducer } from 'app/modules/sho_management_pro/finances/store/vip-upgrades/vip-upgrades.reducer';
import { WindowSalesEffects } from 'app/modules/sho_management_pro/finances/store/window-sales/window-sales.effects';
import { windowSalesReducer } from 'app/modules/sho_management_pro/finances/store/window-sales/window-sales.reducer';
import { GatewayEffects } from 'app/modules/sho_management_pro/gateway/store/gateway.effects';
import { gatewaysReducer } from 'app/modules/sho_management_pro/gateway/store/gateway.reducer';
import { SquareAccountEffects } from 'app/modules/sho_management_pro/gateways/square/square-account/store/square-account.effects';
import { squareAccountsReducer } from 'app/modules/sho_management_pro/gateways/square/square-account/store/square-account.reducer';
import { SquareCatalogItemEffects } from 'app/modules/sho_management_pro/gateways/square/square-catalog-item/store/square-catalog-item.effects';
import { squareCatalogItemsReducer } from 'app/modules/sho_management_pro/gateways/square/square-catalog-item/store/square-catalog-item.reducer';
import { SquareCategoryEffects } from 'app/modules/sho_management_pro/gateways/square/square-category/store/square-category.effects';
import { squareCategoriesReducer } from 'app/modules/sho_management_pro/gateways/square/square-category/store/square-category.reducer';
import { SquareDeviceLocationEffects } from 'app/modules/sho_management_pro/gateways/square/square-device-location/store/square-device-location.effects';
import { squareDeviceLocationsReducer } from 'app/modules/sho_management_pro/gateways/square/square-device-location/store/square-device-location.reducer';
import { SquareDeviceTypeEffects } from 'app/modules/sho_management_pro/gateways/square/square-device-type/store/square-device-type.effects';
import { squareDeviceTypesReducer } from 'app/modules/sho_management_pro/gateways/square/square-device-type/store/square-device-type.reducer';
import { SquareDeviceEffects } from 'app/modules/sho_management_pro/gateways/square/square-device/store/square-device.effects';
import { squareDevicesReducer } from 'app/modules/sho_management_pro/gateways/square/square-device/store/square-device.reducer';
import { SquareLocationProductionEffects } from 'app/modules/sho_management_pro/gateways/square/square-location-production/store/square-location-production.effects';
import { squareLocationProductionsReducer } from 'app/modules/sho_management_pro/gateways/square/square-location-production/store/square-location-production.reducer';
import { SquareOrdersEffects } from 'app/modules/sho_management_pro/gateways/square/square-orders/store/square-orders.effects';
import { squareOrdersReducer } from 'app/modules/sho_management_pro/gateways/square/square-orders/store/square-orders.reducer';
import { SquareRefundsEffects } from 'app/modules/sho_management_pro/gateways/square/square-refunds/store/square-refunds.effects';
import { squareRefundsReducer } from 'app/modules/sho_management_pro/gateways/square/square-refunds/store/square-refunds.reducer';
import { SquareOrdersErrorsEffects } from 'app/modules/sho_management_pro/gateways/square/square-orders-errors/store/square-orders-errors.effects';
import { squareOrdersErrorsReducer } from 'app/modules/sho_management_pro/gateways/square/square-orders-errors/store/square-orders-errors.reducer';
import { SquareProductSalesEffects } from 'app/modules/sho_management_pro/gateways/square/square-product-sales/store/square-product-sales.effects';
import { squareProductSalesReducer } from 'app/modules/sho_management_pro/gateways/square/square-product-sales/store/square-product-sales.reducer';
import { InventoryEffects } from 'app/modules/sho_management_pro/inventory/store/inventory.effects';
import { inventoryReducer } from 'app/modules/sho_management_pro/inventory/store/inventory.reducer';
import { PlaydatesEffects } from 'app/modules/sho_management_pro/play-dates/store/playdate.effects';
import { playdatesReducer } from 'app/modules/sho_management_pro/play-dates/store/playdate.reducer';
import { ProductEffects } from 'app/modules/sho_management_pro/product/store/product.effects';
import { productsReducer } from 'app/modules/sho_management_pro/product/store/product.reducer';
import { ProductionsEffects } from 'app/modules/sho_management_pro/production/store/productions.effects';
import { productionsReducer } from 'app/modules/sho_management_pro/production/store/productions.reducer';
import { PromotionsEffects } from 'app/modules/sho_management_pro/promotion/store/promotions.effects';
import { promotionsReducer } from 'app/modules/sho_management_pro/promotion/store/promotions.reducer';
import { PurchasesEffects } from 'app/modules/sho_management_pro/purchase/store/purchases.effects';
import { purchasesReducer } from 'app/modules/sho_management_pro/purchase/store/purchases.reducer';
import { CostAnalysisEffect } from 'app/modules/sho_management_pro/reports/store/cost-analysis/cost-analysis.effects';
import { costAnalysisReducer } from 'app/modules/sho_management_pro/reports/store/cost-analysis/cost-analysis.reducer';
import { FinalReportEffect } from 'app/modules/sho_management_pro/reports/store/final-report/final-report.effects';
import { finalReportReducer } from 'app/modules/sho_management_pro/reports/store/final-report/final-report.reducer';
import { ReportAnalysisEffect } from 'app/modules/sho_management_pro/reports/store/inventory-sales-analysis/report-analysis.effects';
import { reportAnalysisReducer } from 'app/modules/sho_management_pro/reports/store/inventory-sales-analysis/report-analysis.reducer';
import { ReportEffect } from 'app/modules/sho_management_pro/reports/store/report.effects';
import {
    reportOfficeExpensesReducer,
    reportOnsiteExpensesReducer,
    reportReducer,
    reportShowExpensesReducer,
    reportSummaryReducer,
} from 'app/modules/sho_management_pro/reports/store/report.reducer';
import { RidesEffects } from 'app/modules/sho_management_pro/rides/store/rides.effects';
import {
    rideReducer,
    ridesReducer,
} from 'app/modules/sho_management_pro/rides/store/rides.reducer';
import { RolePermissionsEffects } from 'app/modules/sho_management_pro/role-permissions/store/role-permissions.effects';
import { rolePermissionsReducer } from 'app/modules/sho_management_pro/role-permissions/store/role-permissions.reducer';
import { SalesRepEffects } from 'app/modules/sho_management_pro/sales-rep/store/sales-rep.effects';
import {
    salesRepReducer,
    salesRepsReducer,
} from 'app/modules/sho_management_pro/sales-rep/store/sales-rep.reducer';
import { SalesEffects } from 'app/modules/sho_management_pro/sales/store/sales.effects';
import { salesReducer } from 'app/modules/sho_management_pro/sales/store/sales.reducer';
import { SessionTimesEffects } from 'app/modules/sho_management_pro/session-times/store/session-times.effects';
import {
    sessionTimeReducer,
    sessionTimesReducer,
} from 'app/modules/sho_management_pro/session-times/store/session-times.reducer';
import { ShowsEffects } from 'app/modules/sho_management_pro/show/store/show.effects';
import {
    showReducer,
    showsReducer,
} from 'app/modules/sho_management_pro/show/store/show.reducer';
import { TransfersEffects } from 'app/modules/sho_management_pro/transfers/store/transfers.effects';
import { transfersReducer } from 'app/modules/sho_management_pro/transfers/store/transfers.reducer';
import { UserEffects } from 'app/modules/sho_management_pro/user/store/user.effects';
import { usersReducer } from 'app/modules/sho_management_pro/user/store/user.reducer';
import { VendorsEffects } from 'app/modules/sho_management_pro/vendor/store/vendor.effects';
import { vendorsReducer } from 'app/modules/sho_management_pro/vendor/store/vendor.reducer';
import { VenueEffects } from 'app/modules/sho_management_pro/venue/store/venue.effects';
import { venuesReducer } from 'app/modules/sho_management_pro/venue/store/venue.reducer';

export const ngrxConfig: ApplicationConfig['providers'] = [
    provideStore(),

    // --------------------------------------------------------------------
    // @ Notifications
    // --------------------------------------------------------------------

    // Notifications
    provideEffects(NotificationsEffects),
    provideState({ name: 'notifications', reducer: notificationsReducer }),

    // --------------------------------------------------------------------
    // @
    // --------------------------------------------------------------------

    // Booking
    provideEffects(BookingsEffects),
    provideState({ name: 'bookings', reducer: bookingsReducer }),

    // Common
    provideEffects(CommonEffects),
    provideState({ name: 'common', reducer: commonReducer }),

    // --------------------------------------------------------------------
    // @
    // --------------------------------------------------------------------

    // Employees
    provideEffects(EmployeeEffects),
    provideState({ name: 'employees', reducer: employeesReducer }),

    // Employees Roles
    provideEffects(EmployeeRolesEffects),
    provideState({ name: 'employeeRoles', reducer: employeeRolesReducer }),

    // --------------------------------------------------------------------
    // @ Expenses
    // --------------------------------------------------------------------

    // Expenses
    provideEffects(ExpensesEffects),
    provideState({ name: 'expenses', reducer: expensesReducer }),

    // Promotions
    provideEffects(PromotionsEffects),
    provideState({ name: 'promotions', reducer: promotionsReducer }),

    // Expenses Status
    provideEffects(ExpenseStatusEffects),
    provideState({ name: 'expenseStatus', reducer: expenseStatusReducer }),

    // Expenses Types
    provideEffects(ExpenseTypesEffects),
    provideState({ name: 'expenseTypes', reducer: expenseTypesReducer }),

    // --------------------------------------------------------------------
    // @ Inventory
    // --------------------------------------------------------------------

    // Inventory Items
    provideEffects(InventoryEffects),
    provideState({ name: 'inventory', reducer: inventoryReducer }),

    // Purchases
    provideEffects(PurchasesEffects),
    provideState({ name: 'purchases', reducer: purchasesReducer }),

    // Transfers
    provideEffects(TransfersEffects),
    provideState({ name: 'transfers', reducer: transfersReducer }),

    // --------------------------------------------------------------------
    // @
    // --------------------------------------------------------------------

    // Products
    provideEffects(ProductEffects),
    provideState({ name: 'products', reducer: productsReducer }),

    // Production
    provideEffects(ProductionsEffects),
    provideState({ name: 'productions', reducer: productionsReducer }),

    // Users
    provideEffects(UserEffects),
    provideState({ name: 'users', reducer: usersReducer }),

    // Role Permissions
    provideEffects(RolePermissionsEffects),
    provideState({ name: 'rolePermissions', reducer: rolePermissionsReducer }),

    // Sales Rep
    provideEffects(SalesRepEffects),
    provideState({ name: 'salesReps', reducer: salesRepsReducer }),
    provideState({ name: 'salesRep', reducer: salesRepReducer }),

    // Gateway
    provideEffects(GatewayEffects),
    provideState({ name: 'gateways', reducer: gatewaysReducer }),

    // Square Location Production
    provideEffects(SquareLocationProductionEffects),
    provideState({
        name: 'squareLocationProductions',
        reducer: squareLocationProductionsReducer,
    }),

    // Square Account
    provideEffects(SquareAccountEffects),
    provideState({ name: 'squareAccounts', reducer: squareAccountsReducer }),

    // Square Device Type
    provideEffects(SquareDeviceTypeEffects),
    provideState({
        name: 'squareDeviceTypes',
        reducer: squareDeviceTypesReducer,
    }),

    // Square Device
    provideEffects(SquareDeviceEffects),
    provideState({ name: 'squareDevices', reducer: squareDevicesReducer }),

    // Square Orders
    provideEffects(SquareOrdersEffects),
    provideState({ name: 'squareOrders', reducer: squareOrdersReducer }),

    // Square Refunds
    provideEffects(SquareRefundsEffects),
    provideState({ name: 'squareRefunds', reducer: squareRefundsReducer }),

    // Square Orders Errors
    provideEffects(SquareOrdersErrorsEffects),
    provideState({ name: 'squareOrdersErrors', reducer: squareOrdersErrorsReducer }),

    // Square Device Location
    provideEffects(SquareDeviceLocationEffects),
    provideState({
        name: 'squareDeviceLocations',
        reducer: squareDeviceLocationsReducer,
    }),

    // Square Catalog Items (Gateway Products)
    provideEffects(SquareCatalogItemEffects),
    provideState({
        name: 'squareCatalogItems',
        reducer: squareCatalogItemsReducer,
    }),

    // Square Categories (Gateway Categories)
    provideEffects(SquareCategoryEffects),
    provideState({
        name: 'squareCategories',
        reducer: squareCategoriesReducer,
    }),

    // Square Product Sales
    provideEffects(SquareProductSalesEffects),
    provideState({
        name: 'squareProductSales',
        reducer: squareProductSalesReducer,
    }),

    // Rides
    provideEffects(RidesEffects),
    provideState({ name: 'rides', reducer: ridesReducer }),
    provideState({ name: 'ride', reducer: rideReducer }),

    // Maps
    provideEffects(SearchLocationsEffects),
    provideState({ name: 'searchLocations', reducer: searchLocationsReducer }),
    provideState({ name: 'coordinates', reducer: coordinatesReducer }),

    // Place Types
    provideEffects(PlaceTypesEffects),
    provideState({ name: 'placetypes', reducer: placeTypesReducer }),

    // Playdates
    provideEffects(PlaydatesEffects),
    provideState({ name: 'playdates', reducer: playdatesReducer }),

    // Session Times
    provideEffects(SessionTimesEffects),
    provideState({ name: 'sessionTimes', reducer: sessionTimesReducer }),
    provideState({ name: 'sessionTime', reducer: sessionTimeReducer }),

    // Show
    provideEffects(ShowsEffects),
    provideState({ name: 'shows', reducer: showsReducer }),
    provideState({ name: 'show', reducer: showReducer }),

    // Venue
    provideEffects(VenueEffects),
    provideState({ name: 'venues', reducer: venuesReducer }),

    // Vendors
    provideEffects(VendorsEffects),
    provideState({ name: 'vendors', reducer: vendorsReducer }),

    // --------------------------------------------------------------------
    // @ Finances
    // --------------------------------------------------------------------

    // Sales
    provideEffects(SalesEffects),
    provideState({ name: 'sales', reducer: salesReducer }),

    // Terminal Sales
    provideEffects(TerminalSalesEffects),
    provideState({ name: 'terminalSales', reducer: terminalSalesReducer }),

    // Other Vendors Sales
    provideEffects(OtherVendorsSalesEffects),
    provideState({
        name: 'otherVendorsSales',
        reducer: otherVendorsSalesReducer,
    }),

    // Vip Upgrades
    provideEffects(VipUpgradesEffects),
    provideState({ name: 'vipUpgrades', reducer: vipUpgradesReducer }),

    // Windows Sales
    provideEffects(WindowSalesEffects),
    provideState({ name: 'windowsSales', reducer: windowSalesReducer }),

    // Rides Sales
    provideEffects(RidesSalesEffects),
    provideState({ name: 'ridesSales', reducer: ridesSalesReducer }),

    // Concession
    provideEffects(ConcessionSalesEffects),
    provideState({ name: 'concessionSales', reducer: ConcessionSalesReducer }),

    // Novelties
    provideEffects(NoveltiesSalesEffects),
    provideState({ name: 'noveltiesSales', reducer: NoveltiesSalesReducer }),

    // Concession & Novelties Commissions
    provideEffects(CommissionsEffects),
    provideState({ name: 'commissions', reducer: commissionsReducer }),

    // Total Gross
    provideEffects(TotalGrossEffects),
    provideState({ name: 'totalGross', reducer: TotalGrossReducer }),

    // Parking Sales
    provideEffects(ParkingSalesEffects),
    provideState({ name: 'parkingSales', reducer: parkingSalesReducer }),

    // Other Sales
    provideEffects(OtherSalesEffects),
    provideState({ name: 'otherSales', reducer: otherSalesReducer }),

    // --------------------------------------------------------------------
    // @ Reports
    // --------------------------------------------------------------------

    // Reports
    provideEffects(ReportEffect),
    provideState({ name: 'report', reducer: reportReducer }),
    provideState({ name: 'reportSummary', reducer: reportSummaryReducer }),
    provideState({
        name: 'reportShowExpenses',
        reducer: reportShowExpensesReducer,
    }),
    provideState({
        name: 'reportOfficeExpenses',
        reducer: reportOfficeExpensesReducer,
    }),
    provideState({
        name: 'reportOnsiteExpenses',
        reducer: reportOnsiteExpensesReducer,
    }),

    // Inventory Sales Analysis Report
    provideEffects(ReportAnalysisEffect),
    provideState({ name: 'reportAnalysis', reducer: reportAnalysisReducer }),

    // Final Report
    provideEffects(FinalReportEffect),
    provideState({ name: 'finalReport', reducer: finalReportReducer }),

    // Cost Analysis Report
    provideEffects(CostAnalysisEffect),
    provideState({ name: 'costAnalysis', reducer: costAnalysisReducer }),

    // --------------------------------------------------------------------
    // @ Reports
    // --------------------------------------------------------------------

    provideStoreDevtools({
        maxAge: 25, // Retains last 25 states
        logOnly: !isDevMode(), // Restrict extension to log-only mode
        autoPause: true, // Pauses recording actions and state changes when the extension window is not open
        trace: false, //  If set to true, will include stack trace for every dispatched action, so you can see it in trace tab jumping directly to that part of code
        traceLimit: 75, // maximum stack trace frames to be stored (in case trace option was provided as true)
        connectInZone: true, // If set to true, the connection is established within the Angular zone
    }),
];
